import { render, staticRenderFns } from "./institutionalUser.vue?vue&type=template&id=bdd9cc24&scoped=true&"
import script from "./institutionalUser.vue?vue&type=script&lang=js&"
export * from "./institutionalUser.vue?vue&type=script&lang=js&"
import style0 from "./institutionalUser.vue?vue&type=style&index=0&id=bdd9cc24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd9cc24",
  null
  
)

export default component.exports